import * as yup from 'yup';

export const SystemsFormSchema = yup.object().shape({
    systemName: yup
        .string()
        .label('System Name')
        .required('System name is required')
        .min(2, 'System name must be at least 2 characters')
        .max(128, 'System name must not exceed 100 characters'),

    url: yup
        .string()
        .label('URL')
        .required('URL is required')
        .max(512, 'URL must not exceed 100 characters'),

    ownerUserName: yup.string().label('System Owner').nullable(),

    createdDateUtc: yup.date().label('Created Date').nullable(),

    isActive: yup.boolean().label('System Status').required('System status is required'),

    maintenanceMessage: yup
        .string()
        .label('Maintenance Message')
        .nullable()
        .max(500, 'Maintenance message must not exceed 500 characters'),

    estimatedReturnUtc: yup.date().label('Estimated Return').nullable(),
});
